import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../../api"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalBody,
  Button,
  Label,
  CardTitle,
  Form,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import DataTable from "react-data-table-component"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import Select from "react-select"

const DataTableFactClient = props => {
  var userAuth = JSON.parse(localStorage.getItem("userAuth"))
  const user_id = userAuth.user.id
  //
  const [loading, setLoading] = useState(false)
  const [modalDel, setModalDel] = useState(false)
  const [id, setId] = useState("")
  const [client, setClient] = useState([])
  const [selectClient, setSelectClient] = useState("")
  const [depot, setDepot] = useState([])
  const [selectDepot, setSelectDepot] = useState("")
  const [dateDebut, setDateDebut] = useState("")
  const [dateFin, setDateFin] = useState("")
  // pagination
  const [nbrTotlEl, setNbrTotlEl] = useState(0)
  const [nbrEltperPage, setNbrEltperPage] = useState(5)
  const [filterElement, setFilterElement] = useState("")
  const [mycurrentPage, setMycurrentPage] = useState(1)
  const [resetFirstPage, setResetFirstPage] = useState(false)
  const [data, setData] = useState([])
//////permission//////
const [userdata, setUserdata] = useState([])
const [perm, setPerm] = useState({
  add: 0,
  delete:0,
  edit:0,
  imp:0,
  view:0
});

useEffect(async () => {
  const userAuth = JSON.parse(localStorage.getItem('userAuth'));
  console.log(userAuth)
  setUserdata(userAuth.user.userData)
console.log(userAuth.user.userData)
}, [])


useEffect(() => {
console.log(userdata)
  const typeArticleSubMenu = userdata.find(user => 
    user.sous_menus.some(subMenu => subMenu.sous_menu === "Facture Directe")
  );

  if (typeArticleSubMenu) {
    console.log(typeArticleSubMenu)
    const typeArticlePermission = typeArticleSubMenu.sous_menus.find(
      subMenu => subMenu.sous_menu === "Facture Directe"
    ).permissions[0];
    console.log(typeArticlePermission)
    setPerm(prevPerm => ({
      ...prevPerm,
      add: typeArticlePermission.add,
      delete:typeArticlePermission.delete,
      edit:typeArticlePermission.edit,
      imp:typeArticlePermission.imp,
      view:typeArticlePermission.view
    }));
  }
}, [userdata]);
console.log(perm)
///////////permission////


  const columns = [
    {
      name: "N° fact",
      selector: "numero",
      sortable: false,
      center: true,
    },
    {
      name: "Date",
      // eslint-disable-next-line react/display-name
      cell: row => <div style={{ whiteSpace: "nowrap" }}>{row.date}</div>,
      center: true,
      reorder: true,
    },
    {
      name: "Client",
      // eslint-disable-next-line react/display-name
      cell: row => <div style={{ whiteSpace: "nowrap" }}>{row.codeClient}</div>,
      center: true,
      reorder: true,
    },
   /* {
      name: "Code depot",
      selector: "code_depot",
      sortable: false,
      center: true,
    },
    {
      name: "Depot",
      selector: "depot",
      sortable: false,
      center: true,
    },*/
    // {
    //   name: "Devis/BC",
    //   selector: "",
    //   sortable: false,
    //   center: true,
    // },
    {
      name: "Mnt HT",
      selector: "total_ht",
      sortable: false,
      center: true,
    },
    {
      name: "Mnt TTC",
      selector: "total_ttc",
      sortable: false,
      center: true,
    },
    {
      name: "Consultation",
      // eslint-disable-next-line react/display-name
      cell: row =>
      perm.view == 1 ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
        <Link to={"/DetailFactClient?id=" + row.id}>
          <i
            style={{ color: "mediumslateblue", cursor: "pointer" }}
            className="fas fa-info-circle"
          ></i>
        </Link>
      </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "rgb(167, 163, 163)", cursor: "pointer" }}
            className="fas fa-info-circle"
            title="pas de perm"
          ></i>
        </div>
      ),
      center: true,
      reorder: true,
    },
    {
      name: "Modification",
      // eslint-disable-next-line react/display-name
      cell: row =>
      perm.edit == 1 ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
        <Link to={"/EditFactClient?id=" + row.id}>
          <i
            style={{ color: "cornflowerblue", cursor: "pointer" }}
            className="fas fa-edit"
          ></i>
        </Link>
      </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "rgb(167, 163, 163)", cursor: "pointer" }}
            className="fas fa-edit"
            title="pas de perm"
          ></i>
        </div>
      ),
      center: true,
      reorder: true,
    },
   
    {
      name: "Suppression",
      // eslint-disable-next-line react/display-name
      cell: row =>
        row.count == 0 && perm.delete == 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#ED6464", cursor: "pointer" }}
              onClick={() => toggleDel(row.id)}
              className="fas fa-trash-alt"
            ></i>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "rgb(167, 163, 163)", cursor: "pointer" }}
              className="fas fa-trash-alt"
              title="Type d'article déjà utilisé"
            ></i>
          </div>
        ),
      center: true,
      reorder: true,
    },
      {
      name: "Impression",
      // eslint-disable-next-line react/display-name
      cell: row =>
      perm.imp == 1 ? (
          <div style={{display: "flex", justifyContent: "center" }}>
          <a
          href={
            "http://192.168.5.111:8000/api/pdf/generate_pdf_client?id=" +
            row.id 
           
          }
          target="_blank"
          rel="noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <i
            style={{ color: "#955cd5", cursor: "pointer" }}
            className="fas fa-file-download"
          ></i>
        </a>
        </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "rgb(167, 163, 163)", cursor: "pointer" }}
              className="fas fa-file-download"
              title="Type d'article déjà utilisé"
            ></i>
          </div>
        ),
      center: true,
      reorder: true,
    },

  ]

  const customStyles = {
    rows: {
      style: {
        minHeight: "52px", // override the row height
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        backgroundColor: "#eff2f7",
      
      },
    },
    cells: {
      style: {
        fontSize: "13px",
      },
    },
  }

  useEffect(async () => {
    const resC = await API.get("facture/client/select_client").then(resC => {
      setClient(resC.data.Client)
    })
    const resD = await API.get("facture/client/select_depot").then(resD => {
      setDepot(resD.data.Depot)
    })
    //
    const res = await API.post("facture/client/list", {
      filterElement: filterElement,
      nbrElParPage: 5,
      page: 1,
    }).then(res => {
      setData(res.data.Data[0].FactureClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
    setLoading(true)
  }, [])

  const filterSearch = async e => {
    setFilterElement(e.target.value)
    setMycurrentPage(1)
    const res = await API.post("facture/client/list", {
      filterElement: e.target.value,
      nbrElParPage: nbrEltperPage,
      page: 1,
    }).then(res => {
      setData(res.data.Data[0].FactureClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const newElement = async (page, totalRows) => {
    setMycurrentPage(page)
    const res = await API.post("facture/client/list", {
      filterElement: filterElement,
      nbrElParPage: nbrEltperPage,
      page: page,
    }).then(res => {
      setData(res.data.Data[0].FactureClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const perPage = async (currentRowsPerPage, currentPage) => {
    setMycurrentPage(currentPage)
    const res = await API.post("facture/client/list", {
      filterElement: filterElement,
      nbrElParPage: currentRowsPerPage,
      page: currentPage,
    }).then(res => {
      setData(res.data.Data[0].FactureClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const searchClient = async selectClient => {
    if (selectClient != null) {
      setSelectClient(selectClient)
    } else {
      setSelectClient("")
    }
  }

  const searchDepot = async selectDepot => {
    if (selectDepot != null) {
      setSelectDepot(selectDepot)
    } else {
      setSelectDepot("")
    }
  }

  const search = async () => {
    if (selectClient != "") {
      var client_id = selectClient.value
    } else {
      var client_id = 0
    }
    if (selectDepot != "") {
      var depot_id = selectDepot.value
    } else {
      var depot_id = 0
    }
    // convert date debut
    if (dateDebut != "") {
      let dateD = dateDebut
      let month = "" + (dateD.getMonth() + 1)
      let day = "" + dateD.getDate()
      let year = dateD.getFullYear()
      if (month.length < 2) month = "0" + month
      if (day.length < 2) day = "0" + day
      var convertDateD = [year, month, day].join("-")
    } else {
      var convertDateD = 0
    }
    // convert date fin
    if (dateFin != "") {
      let dateF = dateFin
      let monthOne = "" + (dateF.getMonth() + 1)
      let dayOne = "" + dateF.getDate()
      let yearOne = dateF.getFullYear()
      if (monthOne.length < 2) monthOne = "0" + monthOne
      if (dayOne.length < 2) dayOne = "0" + dayOne
      var convertDateF = [yearOne, monthOne, dayOne].join("-")
    } else {
      var convertDateF = 0
    }
    //
    const res = API.post("facture/client/recherche", {
      client_id: client_id,
      depot_id: depot_id,
      date_debut: convertDateD,
      date_fin: convertDateF,
      nbrEltperPage: nbrEltperPage,
      page: mycurrentPage,
    }).then(res => {
      setData(res.data.Data[0].FactureClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const searchAll = async () => {
    setSelectClient("")
    setSelectDepot("")
    setDateDebut("")
    setDateFin("")
    //
    const res = await API.post("facture/client/list", {
      filterElement: filterElement,
      nbrElParPage: 5,
      page: 1,
    }).then(res => {
      setData(res.data.Data[0].FactureClient)
      setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const toggleDel = id => {
    setModalDel(!modalDel)
    setId(id)
  }

  const toggleSupp = async () => {
    const res = await API.post("facture/client/delete", {
      id: id,
      user_id,
    }).then(res => {
      setModalDel(!modalDel)
      const resD = API.post("facture/client/list", {
        nbrElParPage: nbrEltperPage,
        page: mycurrentPage,
      }).then(resD => {
        setData(resD.data.Data[0].FactureClient)
        setNbrTotlEl(resD.data.Data[0].total)
      })
    })
  }

  return (
    <React.Fragment>
      <div>
        <CardTitle style={{ color: "#556ee6" }} className="h4">
          Critéres de recherche
        </CardTitle>
        <Form className="mt-4">
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Client</Label>
                <Select
                  isClearable={true}
                  isSearchable={true}
                  onChange={e => searchClient(e)}
                  options={client}
                  value={selectClient}
                />
              </div>
            </Col>
            {/* <Col lg="3">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Montant TTC = :</Label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Montant TTC"
                  onChange={e => setMontant(e.target.value)}
                />
              </div>
            </Col> */}
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Depot</Label>
                <Select
                  isSearchable={true}
                  isClearable={true}
                  onChange={e => searchDepot(e)}
                  options={depot}
                  value={selectDepot}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Date Début</Label>
                <Col md={12} className="pr-0">
                  <DatePicker
                    className="form-control ddate"
                    selected={dateDebut}
                    onChange={e => setDateDebut(e)}
                    dateFormat="dd/MM/yyyy"
                  />
                </Col>
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-lastname-input2">Date Fin</Label>
                <Col md={12} className="pr-0">
                  <DatePicker
                    className="form-control ddate"
                    selected={dateFin}
                    onChange={e => setDateFin(e)}
                    dateFormat="dd/MM/yyyy"
                  />
                </Col>
              </div>
            </Col>
          </Row>
        </Form>
        <div
          className="mb-4"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          {" "}
          <Col lg="6">
            <div className="text-center mt-4">
              <button
                type="button"
                style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                className="btn btn-success mb-2 me-2"
                onClick={search}
              >
                Rechercher
              </button>
            </div>
          </Col>
          <Col lg="6">
            <div className="text-center mt-4">
              <button
                type="button"
                style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                className="btn btn-success mb-2 me-2"
                onClick={searchAll}
              >
                Afficher Tout
              </button>
            </div>
          </Col>
        </div>
        {loading ? (
          <Row>
            <div className="mb-2 row">
              <div className="col-md-4">
                <div className="search-box me-2 mb-2 d-inline-block">
                  <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                      <input
                        id="search-bar-0"
                        type="text"
                        aria-labelledby="search-bar-0-label"
                        className="form-control "
                        placeholder="Search"
                        onChange={(currentRowsPerPage, currentPage) =>
                          filterSearch(currentRowsPerPage, currentPage)
                        }
                      />
                    </label>
                    <i className="bx bx-search-alt search-icon" />
                  </div>
                </div>
              </div>
            </div>
            <Col xs="12" >
              <DataTable
                columns={columns}
                data={data}
                noDataComponent="Pas de Données Disponibles"
                customStyles={customStyles}
                highlightOnHover={false}
                pagination={true}
                paginationServer={true}
                onChangePage={(page, totalRows) => newElement(page, totalRows)}
                paginationTotalRows={nbrTotlEl}
                paginationPerPage={nbrEltperPage}
                paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                onChangeRowsPerPage={(currentRowsPerPage, currentPage) =>
                  perPage(currentRowsPerPage, currentPage)
                }
                paginationResetDefaultPage={resetFirstPage}
                paginationComponentOptions={{
                  rowsPerPageText: "Elements par page:",
                  rangeSeparatorText: "de",
                  noRowsPerPage: false,
                }}
              />
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>
      {/* <Delete> */}
      <Modal isOpen={modalDel} toggle={toggleDel} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          toggle={toggleDel}
        >
          {props.t("Suppression d'une facture")}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <p>
                {props.t("Êtes-Vous sûr de vouloir supprimer cette facture ?")}
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleSupp}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDel}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableFactClient))
DataTableFactClient.propTypes = {
  data: PropTypes.array,
  t: PropTypes.any,
}
